export const headCopy = {
  head_playground_title:
    "游乐场 - 一个用于 TypeScript 和 JavaScript 的在线编辑器",
  head_playground_description:
    "可以通过游乐场以安全且可共享的方式在线编写 TypeScript 和 JavaScript。",
  tsconfig_title: "TSConfig 参考 - 所有 TSConfig 选项的文档",
  tsconfig_description:
    "不管是 allowJs 还是 useDefineForClassFields， TSConfig 的参考包含所有关于配置项目的有效的 TypeScript 编译器选项。",
  playground_example_prefix: "游乐场示例 - ",

  head_index_title: "适用于任何规模的 JavaScript",
  head_index_description: "适用于任何规模的 JavaScript",
}
